import type { Task, TaskBucket } from '../schemas/task'
import { PRIORITY_ORDER } from './prio-order'

export type ProjectGroupItem = {
  key: string
  projectId: number | null
  client: string
  projectType: string | null
  items: Task[]
  urgentCount: number
  topPriority: TaskBucket
}

export const groupByProject = (tasks: Task[]): ProjectGroupItem[] => {
  const buckets = new Map<string, ProjectGroupItem>()

  for (const t of tasks) {
    const key = t.projectId != null ? `#${t.projectId}` : '__none'
    const existing = buckets.get(key)
    if (existing) {
      existing.items.push(t)
      if (t.bucket === 'urgent') existing.urgentCount += 1
      if (PRIORITY_ORDER[t.bucket] < PRIORITY_ORDER[existing.topPriority]) {
        existing.topPriority = t.bucket
      }
    } else {
      buckets.set(key, {
        key,
        projectId: t.projectId,
        client: t.client ?? 'Sans dossier',
        projectType: t.projectType,
        items: [t],
        urgentCount: t.bucket === 'urgent' ? 1 : 0,
        topPriority: t.bucket,
      })
    }
  }

  const list = Array.from(buckets.values())
  list.forEach((g) => {
    g.items.sort((a: Task, b: Task) => {
      const byPrio = PRIORITY_ORDER[a.bucket] - PRIORITY_ORDER[b.bucket]
      if (byPrio !== 0) return byPrio
      // Tiebreak: older tasks first so long-waiting work stays at the top.
      return (
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
      )
    })
  })

  return list.sort((a, b) => {
    const byPrio = PRIORITY_ORDER[a.topPriority] - PRIORITY_ORDER[b.topPriority]
    if (byPrio !== 0) return byPrio
    return b.items.length - a.items.length
  })
}
